exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".number-select {\n  display: block;\n  overflow: hidden;\n  margin: 0;\n}\n\n.number-select-item a {\n  cursor: pointer;\n  color: rgba(0, 0, 0, 0.87);\n  padding: 4px 10px;\n  line-height: 15px;\n  font-size: 13px;\n}\n\n.active.number-select-item a {\n  background: #00aa00;\n  border-color: #00aa00;\n  color: #ffffff;\n}\n.active.number-select-item a:hover {\n  background: #008500;\n  border-color: #008500;\n}\n  \n\n:host-context(.has-error) .number-select-item a {\n  border-color: #ff2222;\n  color: #ff2222;\n}\n\n\n\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/import-glob-loader!./app/pages/admin/online-sessions/number-select.component.css
// module id = 1089
// module chunks = 4